import React from "react";
import "./Section1.css";
import Section1Image from "../../../../../assets/images/fbarsrsec1-img1.png";
import Section1Shape1 from "../../../../../assets/images/fbarsrsec1-shape1.png";
import Section1Shape2 from "../../../../../assets/images/fbarsrsec1-shape2.png";
import Section1Dots from "../../../../../assets/images/aboutus-dots.png";
const Section1 = () => {
  return (
    <div className="fbarrsrc1_section">
      <img src={Section1Dots} alt="" className="fbarrsrc1__section_dots" />
      <div className="fbarrsrc1__section_left">
        <div className="fbarrsrc1__section_imgwrap">
          <img
            src={Section1Shape1}
            alt=""
            className="fbarrsrc1__section_shape1"
          />
          <img
            src={Section1Shape2}
            alt=""
            className="fbarrsrc1__section_shape2"
          />
          <img src={Section1Image} alt="" className="fbarrsrc1__section_img" />
        </div>
      </div>
      <div className="fbarrsrc1__section_right">
        <div className="fbarrsrc1__secleft_description">
          <p>
            Owning a bank account abroad likely triggers an FBAR reporting
            obligation on an annual basis. Unfortunately for expats, late filing
            can result in severe FBAR penalties. We are here to keep you current
            and to help you catch up if needed. To get a better understanding of
            the FBAR basics, you can read our introduction to the FBAR below.
            The FBAR form formally referred to as FinCEN Form 114) must be filed
            electronically using the BSA E-Filing System maintained by the U.S.
            Department of the Treasury’s Financial Crimes Enforcement Network
            (“FinCEN”).
          </p>
        </div>
      </div>
    </div>
  );
};

export default Section1;
